module.exports = __webpack_public_path__ + "img/usersIcon_Active.7b4ebf23.png";